import { useCallback, useContext, useEffect, useState } from "react";
import SideSheetDrawer from "../components/SidesheetDrawer";
import { DisclosureHost } from "../hooks/use-disclosure";
import { ZoomContext } from "./zoom-context";
import { Participant } from "./index-types";
import { useParticipantsChange } from "./useParticipantsChange";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  IconButton,
  InputAdornment,
  List,
  TextField,
} from "@mui/material";
import Text from "../components/Text";
import OutlineCard from "../components/OutlineCard";
import Flex from "../components/Flex";

interface Props {
  disclosureHost: DisclosureHost;
}
const ParticipantsListDrawer = ({ disclosureHost }: Props) => {
  const [searchString, setSearch] = useState<string>("");
  const [currUsers, setCurrUsers] = useState<Participant[]>([]);
  const [filCurrUsers, setFilCurrUsers] = useState<Participant[]>([]);

  useEffect(() => {
    setFilCurrUsers(
      currUsers.filter((user) =>
        user?.userIdentity
          ?.toLowerCase()
          .includes(searchString.toLocaleLowerCase())
      )
    );
  }, [searchString]);

  const zmClient = useContext(ZoomContext);
  if (!zmClient) {
    throw new Error("zmClient is not available. ");
  }
  const onParticipantsChange = useCallback(
    (participants: Participant[]) => {
      const result: Participant[] = [];

      participants.forEach((user) => {
        if (user.isHost || (!user.isHost && user.subsessionId)) {
          result.push(user);
        }
      });
      setCurrUsers(result);
      setFilCurrUsers(result);
      setSearch("");
    },
    [zmClient]
  );
  useParticipantsChange(zmClient, onParticipantsChange);

  return (
    <SideSheetDrawer
      title="People"
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      w="20vw"
    >
      <Box width={"100%"}>
        <TextField
          placeholder="Search for people"
          fullWidth
          variant="outlined"
          value={searchString}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            sx: {
              "& .MuiInputBase-input": { fontSize: "14px" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Text marginTop={"20px"}>In Meeting</Text>

      <List>
        {filCurrUsers?.length > 0 ? (
          filCurrUsers.map((user) => (
            <OutlineCard
              key={user.userId}
              sx={{
                marginTop: "10px",
              }}
            >
              <Flex gap={1}>
                <Avatar />
                <Flex flexDirection={"column"} gap={1}>
                  <Text fontWeight={"bold"}>{user.userIdentity}</Text>
                  <Text>{user.isHost && "Host"}</Text>
                </Flex>
              </Flex>
            </OutlineCard>
          ))
        ) : (
          <Text>No Results</Text>
        )}
      </List>
    </SideSheetDrawer>
  );
};

export default ParticipantsListDrawer;
